/* eslint-disable @typescript-eslint/no-unused-vars */
import { inject, Injectable } from '@angular/core';

import * as grpc_web from 'grpc-web';
import { CookieService } from 'ngx-cookie-service';
import { HeaderService } from '@recovery/app/core/api/grpc/services/header.service';
import { LocaleService } from '@recovery/app/core/services/locale.service';
import { SSRService } from '@recovery/app/core/services/ssr.service';

import { GRPC_ENVIRONMENT } from '../providers/environment.provider';

@Injectable()
export abstract class GrpcCommonService<T> {
  protected readonly _cookieService = inject(CookieService);
  private readonly _env = inject(GRPC_ENVIRONMENT, { optional: true });
  private locale: LocaleService = inject(LocaleService);
  private ssrService: SSRService = inject(SSRService);
  private headerService: HeaderService = inject(HeaderService);

  protected abstract _GrpcContract: T;

  constructor() {}

  protected getMetadata() {
    return this.headerService.setHeader();
  }
}
